<template>
  <div id="app">
    <div class="head-box">
      <div class="logo-box">
        <img src="./assets/logo.png">
      </div>
      <div>
        <el-menu :default-active="activeIndex"  @select="handleSelect" class="head-menu-box" mode="horizontal" active-text-color="#195AFF" text-color="#898F9D" style="border-bottom: none;">
          
          <el-menu-item index="1" class="head-menu-item" style="border-bottom: none;font-size: 18px;">
             首页
            <div class="active-line" v-if="activeIndex==1"></div>
          </el-menu-item>
          <el-menu-item index="2" class="head-menu-item" style="border-bottom: none;font-size: 18px;">
            关于我们
            <div class="active-line" v-if="activeIndex==2"></div>
          </el-menu-item>
          <el-menu-item index="3" class="head-menu-item" style="border-bottom: none;font-size: 18px;">
            产品服务
            <div class="active-line" v-if="activeIndex==3"></div>
          </el-menu-item>
          <el-menu-item index="4" class="head-menu-item" style="border-bottom: none;font-size: 18px;">
            资讯信息
            <div class="active-line" v-if="activeIndex==4"></div>
          </el-menu-item>
          <el-menu-item index="5" class="head-menu-item" style="border-bottom: none;font-size: 18px;">
            人才招聘
            <div class="active-line" v-if="activeIndex==5"></div>
          </el-menu-item>
          <el-menu-item index="6" class="head-menu-item" style="border-bottom: none;font-size: 18px;">
            联系我们
           <div class="active-line" v-if="activeIndex==6"></div>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    
    <router-view :activeIndex="activeIndex" @changeactiveindex="changeactiveindex" />

    <div class="footer-box" >
      <div class="footer-text">
        互联网药品信息服务资格证书 证书编号：（苏）-非经营性-2023-0150&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;苏公网安备32050502011667号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ICP主体备案号 苏ICP备2023039181号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;主办单位名称 苏州益海邦生物科技有限公司
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeIndex: '1'
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex=key
      if(key==1){
        this.$router.push('/');
      }
      if(key==2){
        this.$router.push('/aboutus');
      }
      if(key==3){
        this.$router.push('/productservice');
      }
      if(key==4){
        this.$router.push('/information');
      }
      if(key==5){
        this.$router.push('/recruit');
      }
      if(key==6){
        this.$router.push('/contactus');
      }
    },
    changeactiveindex(params){
      this.activeIndex=params
    }
  }
}
</script>

<style>
body{
  display: flex;
  flex-direction: column;
  align-items: center;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 19px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.head-box{
  display: flex;
  justify-content: space-between;
  
  width: 1080px;
}
.logo-box{
  width: 187px;
  height: 42px;
}
.logo-box img{
  width: 100%;
  height: 100%;
}

.head-menu-item{
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.active-line{
  height: 2px;
  width: 16px;
  background-color: #195AFF;
  margin-top: -12px;
}
.footer-box{
  width:99vw;
  display: flex;
  height: 70px;
  background-color: #161B26;
  justify-content: center;
  align-items: center;
}
.footer-text{
  font-size: 12px;
  font-weight: 400;
  color: #C0C0C3;
  line-height: 17px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue